export enum BrowserEnum {
  unknown = 'unknown',
  edge = 'edge',
  safari = 'safari',
  opera = 'opera',
  chrome = 'chrome',
  firefox = 'firefox'
}
